module.exports = "<input class=input type=text :placeholder=placeholder :readonly=readonly v-model=value /> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-bulma-datepicker/src/singleInput.html
// module id = 790
// module chunks = 2